export const CoreWhiteIcon = ({ id }) => (
  <svg width="60" height="56" viewBox="0 0 60 56" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Group 1261161825">
      <g id="Group 1261159924">
        <path
          id="Vector"
          d="M29.6617 35.1084C33.2823 35.1084 36.2174 32.2687 36.2174 28.7659C36.2174 25.263 33.2823 22.4233 29.6617 22.4233C26.0411 22.4233 23.106 25.263 23.106 28.7659C23.106 32.2687 26.0411 35.1084 29.6617 35.1084Z"
          fill="white"
        />
        <g id="Group 1261159917">
          <path
            id="Vector_2"
            d="M36.4365 7.10771C36.4365 3.57568 33.4784 0.712402 29.8296 0.712402C26.1807 0.712402 23.2227 3.57568 23.2227 7.10771V14.1366C23.2227 17.6686 26.1807 20.5319 29.8296 20.5319C33.4784 20.5319 36.4365 17.6686 36.4365 14.1366V7.10771Z"
            fill="url(#paint0_linear_3732_1157)"
          />
          <path
            id="Vector_3"
            d="M10.583 16.0767C7.11087 14.9853 3.3821 16.8222 2.25454 20.1796C1.12697 23.5371 3.02758 27.1436 6.49967 28.235L13.4093 30.4071C16.8814 31.4986 20.6101 29.6616 21.7377 26.3042C22.8653 22.9468 20.9647 19.3402 17.4926 18.2488L10.583 16.0767Z"
            fill="url(#paint1_linear_3732_1157)"
          />
          <path
            id="Vector_4"
            d="M11.3969 42.6448C9.25104 45.5023 9.90455 49.5009 12.8566 51.5759C15.8086 53.6509 19.9412 53.0166 22.0871 50.1591L26.3575 44.4726C28.5034 41.6151 27.8498 37.6166 24.8978 35.5415C21.9458 33.4665 17.8132 34.1009 15.6673 36.9583L11.3969 42.6448Z"
            fill="url(#paint2_linear_3732_1157)"
          />
          <path
            id="Vector_5"
            d="M37.7764 50.0874C39.9223 52.9449 44.0549 53.5792 47.007 51.5042C49.959 49.4292 50.6125 45.4306 48.4666 42.5732L44.1962 36.8867C42.0504 34.0292 37.9177 33.3949 34.9657 35.4699C32.0137 37.5449 31.3602 41.5434 33.506 44.4009L37.7764 50.0874Z"
            fill="url(#paint3_linear_3732_1157)"
          />
          <path
            id="Vector_6"
            d="M8.50834 28.5142C12.1486 28.5142 15.0997 25.6591 15.0997 22.1372C15.0997 18.6153 12.1486 15.7603 8.50834 15.7603C4.86804 15.7603 1.91699 18.6153 1.91699 22.1372C1.91699 25.6591 4.86804 28.5142 8.50834 28.5142Z"
            fill="white"
          />
          <path
            id="Vector_7"
            d="M29.8321 13.4432C33.4789 13.4432 36.4352 10.583 36.4352 7.05483C36.4352 3.52666 33.4789 0.666504 29.8321 0.666504C26.1853 0.666504 23.229 3.52666 23.229 7.05483C23.229 10.583 26.1853 13.4432 29.8321 13.4432Z"
            fill="white"
          />
          <path
            id="Vector_8"
            d="M16.7414 52.8163C20.3945 52.8163 23.3559 49.9512 23.3559 46.4169C23.3559 42.8827 20.3945 40.0176 16.7414 40.0176C13.0884 40.0176 10.127 42.8827 10.127 46.4169C10.127 49.9512 13.0884 52.8163 16.7414 52.8163Z"
            fill="white"
          />
          <path
            id="Vector_9"
            d="M43.1345 52.7492C46.7797 52.7492 49.7347 49.8903 49.7347 46.3636C49.7347 42.837 46.7797 39.978 43.1345 39.978C39.4892 39.978 36.5342 42.837 36.5342 46.3636C36.5342 49.8903 39.4892 52.7492 43.1345 52.7492Z"
            fill="white"
          />
          <path
            id="Vector_10"
            d="M49.1617 16.0767C52.6338 14.9853 56.3625 16.8222 57.4901 20.1796C58.6177 23.5371 56.7171 27.1436 53.245 28.235L46.3353 30.4071C42.8632 31.4986 39.1345 29.6616 38.0069 26.3042C36.8793 22.9468 38.78 19.3402 42.2521 18.2488L49.1617 16.0767Z"
            fill="url(#paint4_linear_3732_1157)"
          />
          <path
            id="Vector_11"
            d="M51.2373 28.5147C47.597 28.5147 44.6459 25.6596 44.6459 22.1377C44.6459 18.6158 47.597 15.7607 51.2373 15.7607C54.8776 15.7607 57.8286 18.6158 57.8286 22.1377C57.8286 25.6596 54.8776 28.5147 51.2373 28.5147Z"
            fill="white"
          />
        </g>
      </g>
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_3732_1157"
        x1="29.7863"
        y1="-11.5703"
        x2="29.9224"
        y2="21.8092"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.348958" stop-color="white" stop-opacity="0.95" />
        <stop offset="1" stop-color="white" stop-opacity="0.2" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3732_1157"
        x1="-9.83306"
        y1="16.4238"
        x2="22.8171"
        y2="27.2322"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.348958" stop-color="white" stop-opacity="0.95" />
        <stop offset="1" stop-color="white" stop-opacity="0.2" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_3732_1157"
        x1="5.42924"
        y1="61.5374"
        x2="24.7226"
        y2="33.8451"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.348958" stop-color="white" stop-opacity="0.95" />
        <stop offset="1" stop-color="white" stop-opacity="0.2" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_3732_1157"
        x1="54.5042"
        y1="61.4165"
        x2="34.9756"
        y2="33.8788"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.348958" stop-color="white" stop-opacity="0.95" />
        <stop offset="1" stop-color="white" stop-opacity="0.2" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_3732_1157"
        x1="69.5777"
        y1="16.4238"
        x2="36.9275"
        y2="27.2322"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.348958" stop-color="white" stop-opacity="0.95" />
        <stop offset="1" stop-color="white" stop-opacity="0.2" />
      </linearGradient>
    </defs>
  </svg>
);
